export default "__VITE_ASSET__BNFFcI39__"